import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Input, Button, ListGroup, ListGroupItem } from "reactstrap";
import { Loading } from "../../../views/Loading";
import ProductType from "../../../../backoffice/dtos/products/productType";
import { useGetProductTypesQuery } from "../../../../backoffice/apis/productTypeAPI";
import ProductTypeSettingsModal from "./ProductTypeSettingsModal";

export default function ProductTypeSettings(
    {
        shown
    }: {
        shown: Boolean
    }
) {
    const [searchText, setSearchText] = useState<string>();
    const [modalData, setModalData] = useState<{open: boolean, productType: ProductType | undefined}>({open: false, productType: undefined});
    const { data: productTypes } = useGetProductTypesQuery(undefined, {skip: !shown, refetchOnMountOrArgChange: true});
    const { t } = useTranslation(['products','common', 'product_groups', 'measurement_units'])

    const filteredData = useMemo(() => {
        if (!searchText || !productTypes) {
            return productTypes;
        }
        return productTypes.filter(
            (it) => {
                return it.description.includes(searchText);
            }
        )
    }, [productTypes, searchText])

    const handleChange = useCallback(
        (
            {
                target: { value },
            }: React.ChangeEvent<HTMLInputElement>
        ) => {
            if (value.length === 0) {
                setSearchText(undefined);
            } else {
                setSearchText(value)
            }
        },
    [])

    const openModal = useCallback((productType: ProductType | undefined) => {
        setModalData({ open: true, productType })
    }, [])

    const closeModal = useCallback(() => {
        setModalData({ open: false, productType: undefined })
    }, [])

    return (
        <>
            <Container className="my-2">
                <Row>
                    <Col>
                        <Input value={searchText} onChange={handleChange} placeholder={t('search', { ns: 'common' })} />
                    </Col>
                    <Col sm="auto">
                        <Button color='primary' onClick={() => openModal(undefined)}>
                            <span className='fa fa-lg fa-plus me-2' />{t('Add', { ns: 'common' })}
                        </Button>
                    </Col>
                </Row>
                <ListGroup className='mt-4'>
                    <ListGroupItem >
                        <Row>
                            <Col lg={2}><h5> {t('Name', { ns: 'common' })} </h5></Col>
                            <Col lg={2}></Col>
                        </Row>
                    </ListGroupItem>
                    {filteredData
                        ? filteredData.map(
                            (productType, index) => (
                                <ListGroupItem key={index} >
                                    <Row divider>
                                        <Col className='d-flex flex-column justify-content-center'>{productType.description}</Col>
                                        <Col lg="auto" className='d-flex justify-content-end'>
                                            <Button color="primary " className="mx-1" onClick={() => openModal(productType)} >
                                                <i className='fa fa-edit fa-lg'></i>
                                            </Button>
                                        </Col>
                                    </Row>
                                </ListGroupItem>
                            )
                        )
                        : <Loading className="m-2"/>
                    }
                </ListGroup>
            </Container>
            {
                modalData.open
                    && <ProductTypeSettingsModal productType={modalData.productType!} isOpen={modalData.open} toggle={closeModal}/>
            }
        </>
    );
}
